<template>
  <div>
    <component :is="TUICallKitVisible && isPC ? 'el-dialog' : 'div'"
      :visible="TUICallKitVisible"
      :modal="false"
      :modal-append-to-body="false"
      top="0"
      height="100%"
      v-dialogDrag
      :dragOption="dragOption"
      :show-close="false"
      :custom-class="TUICallKitVisible && isPC ? 'drag-dialog-wrapper-dialog-trtc' + (minimized ? ' minimized' : '') : ''"
      :class="TUICallKitVisible && isPC ? 'trtc-previewer-pc':''"
    >
      <TUICallKit class="callkit-container" ref="TUICallKitRef"
      :videoDisplayMode="VideoDisplayMode.CONTAIN"
      style="z-index: 9999"
      :allowedMinimized="true"  :allowedFullScreen="true" :statusChanged="statusChanged" :onMinimized="onMinimized" />
    </component>
  </div>
</template>
<script>
import { getPlatform } from '@tencentcloud/universal-api';
import { TUICallKit, VideoDisplayMode  } from '@tencentcloud/call-uikit-vue2';
export default {
  components: {
    TUICallKit
  },
  data() {
    return {
      TUICallKitVisible: false,
      VideoDisplayMode,
      isPC: getPlatform() === 'pc',
      minimized: null,
      dragOption: JSON.stringify({
        initStyle: { 
          left: 'calc(50% - 25rem)',
          top: 'calc(50% - 18rem)',
          width: '50rem',
          height: '36rem',
        },
      })
    }
  },
  methods: {
    statusChanged(status) {
      this.TUICallKitVisible = status && status.newStatus !== 'idle';
      if(this.TUICallKitVisible === false) {
        this.minimized = null;
      }
    },
    onMinimized(e) {
      this.minimized = !e;
      this.$nextTick(() => {
        try {
          const dragDom = document.querySelector('.drag-dialog-wrapper-dialog-trtc');
          const dom = document.querySelector('.float-window-container.pc');
          // 保存当前的宽高位置
          
          dragDom.setAttribute('data-top', dragDom.offsetTop);
          dragDom.setAttribute('data-left', dragDom.offsetLeft);
          if(!e) {
            dom.style.position = 'relative';
            dom.style.zIndex = '1';
            dom.style.marginTop = '-56px';
            // 将dom 移动到
            this.$refs.TUICallKitRef.$el.parentElement.appendChild(dom);
            
            dragDom.setAttribute('data-width', dragDom.offsetWidth);
            dragDom.setAttribute('data-height', dragDom.offsetHeight);
            // 设置新的宽高
            dragDom.style.width = '200px';
            dragDom.style.height = '110px';
            if(dragDom.offsetTop < 0) {
              dragDom.style.top = '0';
            }
            if(dragDom.offsetLeft < 0) {
              dragDom.style.left = '0';
            }
          } else {
            // 将dom 移动到
            dom.style.position = 'absolute';
            dom.style.marginTop = '0';
            this.$refs.TUICallKitRef.$el.querySelector('#source').appendChild(dom);
            // 恢复原来的宽高
            dragDom.style.width = dragDom.getAttribute('data-width') + 'px';
            dragDom.style.height = dragDom.getAttribute('data-height') + 'px';
            dragDom.style.top = dragDom.getAttribute('data-top') + 'px';
            dragDom.style.left = dragDom.getAttribute('data-left') + 'px';
          }
        } catch (error) {
          console.error('调整小窗位置失败', error);
        }
      })
    }
  }
}
</script>
<style lang="scss">
/* stylelint-disable-next-line */
$left: var(--callLeft, calc(50% - 25rem));
/* stylelint-disable-next-line */
$top: var(--callTop, calc(50% - 18rem));
/* stylelint-disable-next-line */
$width: var(--callWidth, 50rem);
/* stylelint-disable-next-line */
$height: var(--callHeight, 36rem);

.app-pc .callkit-container {
  position: absolute !important;
  z-index: 1 !important;
}
.app-pc .groupcall-media-container.pc.two-layout {
  margin-top: 40px !important;
  // margin-top: 32px !important;
  height: calc(100% - 160px);
  .tk-grid-item.pc {
    height: 100% !important;
  }
}
.app-pc .float-window-container.pc {
  .float-control-panel {
    border-radius: 0;
    box-shadow: none;
    background-color: #f5f5f5;
    justify-content: space-around;
    width: 100%;
    margin-top: 15px;
    .float-control-item-icon {
      &:nth-of-type(2) {
        .float-control-item-icon-container {
          img {
            transform: scale(.7);
          }
        }
      }
      &:last-child {
        .float-control-item-icon-container {
          img {
            transform: scale(.55);
          }
        }
      }
      .float-control-item-icon-container {
        background-color: #ffffff;
        width: 46px;
        height: 46px;
        margin: 0;
        img {
          /* 关键属性：防止图片浮起和拖动 */
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          user-select: none;
          -webkit-user-drag: none;
          object-fit: contain;
          transform: scale(.8);
        }
      }
    }
  }
  
}
.app-h5 .callkit-container {
  position: fixed !important;
  left: $left !important;
  top: $top !important;
  width: $width !important;
  height: $height !important;
}
/* 1. 穿透背景，使底层可点击 */
.trtc-previewer-pc {
  background: none !important;
  pointer-events: none;
}
/* 2. 恢复弹窗主体的点击事件 */
.drag-dialog-wrapper-dialog-trtc {
  pointer-events: auto;
  // margin: 0 !important; /* 清除 ElementUI 默认的 15vh 偏移 */
  position: relative;   /* 配合指令中的 left/top 移动 */
  display: flex;
  flex-direction: column;
  overflow: visible !important;
  background: none !important; /* 背景半透明（白色 20% 不透明度） */
  // backdrop-filter: blur(10px);           /* 毛玻璃关键：模糊背后内容 */
  // -webkit-backdrop-filter: blur(10px);   /* Safari 兼容 */
  border-radius: 12px;
  border: none;
  box-shadow: none !important;

  .el-dialog__header {
    text-align: center;
    user-select: none;
    padding: 0;
    position: absolute;
    width: calc(100% - 62px);
    left: 0;
    top: 0;
    height: 34px;
    z-index: 2;
    .el-icon-close {
      font-size: 24px;
    }
  }
  .el-dialog__body {
    padding: 0;
    background: none;
    flex: 1;
  }
  &.minimized {
    background: #f5f5f5 !important;
    box-shadow: 0 0 15px rgba(181, 181, 181, 0.6) !important;
    border-radius: 12px;
    .resizer {
      display: none;
    }
    .el-dialog__header {
      height: 34px;
      border-bottom: 1px solid #e6e6e6;
      position: relative;
      width: 100%;
    }
  }
  /* 通用感应区样式 */
  .resizer {
    position: absolute;
    z-index: 10;
  }

  /* 四条边 */
  .resizer.n { top: -5px; left: 0; width: 100%; height: 10px; cursor: n-resize; }
  .resizer.s { bottom: -5px; left: 0; width: 100%; height: 10px; cursor: s-resize; }
  .resizer.e { right: -5px; top: 0; width: 10px; height: 100%; cursor: e-resize; }
  .resizer.w { left: -5px; top: 0; width: 10px; height: 100%; cursor: w-resize; }

  /* 四个角 */
  .resizer.nw { top: -8px; left: -8px; width: 16px; height: 16px; cursor: nwse-resize; z-index: 11; }
  .resizer.ne { top: -8px; right: -8px; width: 16px; height: 16px; cursor: nesw-resize; z-index: 11; }
  .resizer.sw { bottom: -8px; left: -8px; width: 16px; height: 16px; cursor: nesw-resize; z-index: 11; }
  .resizer.se { bottom: -8px; right: -8px; width: 16px; height: 16px; cursor: nwse-resize; z-index: 11; }
}
</style>